import React, { Component } from 'react'

import RegexVerification from './regex_verification'
import Controls from '../common/controls'
import Checkbox from '../common/checkbox'
import AriaMessage from '../common/ariaMessage';

export default class AssessmentJPMC extends Component {
  constructor(props) {
    super(props)
    this.props.updateActivePage(null)

    this.state = {
      input: {
        height: { value: '', type: 'text', required: false }, 
        weight: { value: '', type: 'text', required: false },
        isPregnant: { 
          value: {
            'pregnant': false
          }, 
          type: 'checkbox', required: false 
        },  
        health: { 
          value: {
            'glucose': false,
            'triglycerides': false,
            'blood-pressure': false,
            'hdl': false,
            'bmi': false
          }, 
          type: 'checkbox', required: false 
        }
      },
      bmiValue: null,
      eligible: null,
      focused: ''
    }

    this.focusElements = {}

    for (let name in this.state.input) {
      this.focusElements[name] = React.createRef()
    }
    
    this.next = this._next.bind(this)
    this.calculateBMI = this._calculateBMI.bind(this)
    this.isEligible = this._isEligible.bind(this)
  }

  handleChange(name, valueOrEvent) {
    switch (this.state.input[name].type) {
      case 'text':
        const curInputValue = valueOrEvent.target.value
        if (RegexVerification[name].test(curInputValue) || curInputValue === '') {
          this.setState({ 
            input: { ...this.state.input,
              [name]: {...this.state.input[name], 
                value: curInputValue 
              }
            }
          })
        }
      break
      case 'checkbox':
        this.setState({ 
          input: { ...this.state.input, 
            [name]: { ...this.state.input[name], 
              value: { ...this.state.input[name].value,
                [valueOrEvent]: !this.state.input[name].value[valueOrEvent]
              }
            }
          }
        })
      break
      default: break
    }
  }
  
  onFocus(measurement) {
    this.setState({ focused: measurement })
  }

  onBlur() {
    this.setState({ focused: '' })
  }
  
  annouce() {
    if (this.state.focused === 'weight') {
      return (
        <AriaMessage message="Enter your weight in pounds" />
      )
    } else if (this.state.focused === 'height') { 
      return (
        <AriaMessage message="Enter your height in inches" />
      )
    }
  }

  _next(e) {
    return this.props.next(this.props.match.path, this.state.input)
  }

  _calculateBMI() {
    let bmi = 0
    let newState = this.state
    if (this.state.input.height.value && this.state.input.weight.value) {
      let height = this.state.input.height.value
      let weight = this.state.input.weight.value
      bmi = parseFloat(703 * weight / (height * height)).toFixed(1) || 0
      if (bmi >= 28) {
        newState.input.health.value['bmi'] = true
      }
      else {
        newState.input.health.value['bmi'] = false
      }
    }
    newState.bmiValue = bmi
    this.setState(newState)
  }

  _isEligible() {
    const eligible = this.calculateEligible()
    let newState = this.state
    newState.eligible = eligible
    this.setState(newState)
  }

  getBMI() {
    const style = this.state.bmiValue !== null ? "block" : "none" 
    return(
      <div aria-live="assertive" aria-atomic="true">
        <span key={this.state.bmiValue} style={{ display: style }} className="bmi-value">Your BMI is: {this.state.bmiValue}</span>      
      </div>
    )
  }

  calculateEligible() {
    const riskAnswers = this.state.input.health.value
    let riskCount = 0;
    if (!this.state.input.isPregnant.value['pregnant']) {
      if (riskAnswers['bmi'])
        return true
      for (let property in riskAnswers){
        if (riskAnswers[property]) {
          riskCount++
          if(riskCount >= 2)
            return true
        }
      }
    }
    return false
  }

  displayEligibility() {
    if (this.state.eligible === true) {
      return (
        <div id="isEligible" className="assessment-eligible" aria-live="assertive" aria-atomic="true" tabIndex="-1">
          <span>You are eligible for the Newtopia program.</span>
          <br/>
          <Controls className="screener-button" nextLabel="START REGISTRATION" next={this.next} />
        </div>
      )
    }
    else if (this.state.eligible === false) {
      return (
        <div id="isEligible" className="assessment-ineligible" aria-live="assertive" aria-atomic="true" tabIndex="-1">
          <span><strong>You are currently not eligible for the Newtopia program.</strong></span>
          <br/>
          <br />
          <span><strong>The Newtopia program is beneficial to employees that are at risk for chronic diseases. Right now you are not eligible based on the criteria listed above. To learn about other JPMC Wellness Programs please visit My Health via me@jpmc or contact your health care company.</strong></span>
        </div>
      )
    }
    return (
      <div id="isEligible" className="assessment-ineligible" aria-live="assertive" aria-atomic="true" tabIndex="-1"></div>
    )
  }

  componentDidMount() {
    var focusable = document.querySelectorAll('[tabindex]:not([tabindex="-1"])');
    focusable && focusable[0] && focusable[0].focus() 
    window.scrollTo(0, 0)
  }

  getCheckBoxLabel(name) {
    switch(name) {
      case 'pregnant':
        return 'Currently pregnant'
      case 'bmi':
        return 'BMI is 28 or greater'
      case 'glucose':
        return 'Blood glucose levels > or = 100 mg/dl OR A1C > or = 5.7%'
      case 'triglycerides':
        return 'Triglycerides > or = 150 mg/dl'
      case 'blood-pressure':
        return 'Blood pressure > or = 130/85 mm HG'
      case 'hdl':
        return 'HDL levels < or = 50 mg/dl for women and < or = 40 mg/dl for men'
      default: return null
    }
  }

  render() {
    let displayEligibility = this.displayEligibility()
    return (
      <div id="assessment_p2" className="assessment-container">
        <div className="left">
          <h1 className="assessment-header">If you are unable to access this site please call Client Care at <a href="tel:+18886398181">1-888-639-8181</a></h1>
          <hr />
          <p className="assessment-header">We are excited in your interest in the Newtopia program. You are already one step closer to achieving a healthier and happier you!</p>
          <p className="assessment-header">We would like to find out more about you to see if you are eligible for the program. This information is for assessment ONLY. ALL information is confidential and will NOT be shared with your employer or insurer.</p>
          <hr />
          <div role="group" aria-labelledby="assesment_pregnant_bmi">
            <h2 id="assesment_pregnant_bmi" className="assessment-header"><strong>Please check any of the following that apply to determine eligibility for the Newtopia program</strong></h2>
            <br />
            <div className="form-input">
              <Checkbox 
                key={'pregnant'}
                checked={this.state.input.isPregnant.value['pregnant']}
                onChange={this.handleChange.bind(this, "isPregnant", 'pregnant')}
                ariaDescribedby="pregnancy_note"
                value={'pregnant'}
                info={this.getCheckBoxLabel('pregnant')}
              />
              <div id="pregnancy_note"><strong>PLEASE NOTE: </strong> Employees who are currently pregnant are not eligible for the Newtopia program</div>
            </div>
            <br />
            <div className="form-input">
              <Checkbox key={'bmi'} checked={this.state.input.health.value['bmi']} onChange={this.handleChange.bind(this, "health", 'bmi')} value={'bmi'} info={this.getCheckBoxLabel('bmi')} />
              To calculate your Body Mass Index (BMI), enter your height and weight:
            </div>
            <br />
            <div className="assessment-bmi">
              <div className="assessment-input">
                <label for="weight-input" className="left-bmi">What is your weight? </label>
                <input id="weight-input" className="assessment-text-input" value={this.state.input["weight"].value} type="text" onChange={this.handleChange.bind(this, "weight")} onFocus={this.onFocus.bind(this, "weight")} onBlur={this.onBlur.bind(this)} aria-label="What is your weight in pounds"/>lb
              </div>
              <div className="assessment-input">
                <label for="height-input" className="left-bmi">What is your height? </label>
                <input id="height-input" className="assessment-text-input" value={this.state.input["height"].value} type="text" onChange={this.handleChange.bind(this, "height")} onFocus={this.onFocus.bind(this, "height")} onBlur={this.onBlur.bind(this)} aria-label="What is your height in inches"/>in
              </div>
              {this.annouce()}
              Click <button className="button bmi" onClick={this.calculateBMI} aria-label="Click to calculate BMI">CALCULATE NOW</button> to see your results.
              {this.getBMI()}
            </div>
          </div>
          <div className="form-input">
            <div role="group" aria-labelledby="assessment_factors_text">
              <h3 id="assessment_factors_text">OR</h3>
              <Checkbox key={'glucose'} checked={this.state.input.health.value['glucose']} onChange={this.handleChange.bind(this, "health", 'glucose')} value={'glucose'} info={this.getCheckBoxLabel('glucose')} />
              <Checkbox key={'triglycerides'} checked={this.state.input.health.value['triglycerides']} onChange={this.handleChange.bind(this, "health", 'triglycerides')} value={'triglycerides'} info={this.getCheckBoxLabel('triglycerides')} />
              <Checkbox key={'blood-pressure'} checked={this.state.input.health.value['blood-pressure']} onChange={this.handleChange.bind(this, "health", 'blood-pressure')} value={'blood-pressure'} info={this.getCheckBoxLabel('blood-pressure')} />
              <Checkbox key={'hdl'} checked={this.state.input.health.value['hdl']} onChange={this.handleChange.bind(this, "health", 'hdl')} value={'hdl'} info={this.getCheckBoxLabel('hdl')} />
            </div>
          </div>
          <br />
          <button className="button eligible" onClick={this.isEligible}>CHECK ELIGIBILITY</button>
          <br />
          {displayEligibility}
        </div>
        <div className="right desk-img"><img src="https://image.my.newtopia.com/lib/fe9113727c60037c75/m/1/4919197d-edb3-4314-aa62-cbd8574aa6b5.png" alt="person using a computer"/></div>
      </div>
    )
  }
}